<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
      :customSub="true"
    />
    <MapBox ref="mapBox" />
  </section>
</template>

<script>
import MapBox from './mapBox';
import {addMonthForDate} from '@qx/utils';
export default {
  components: {
    MapBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          { // 位置来源
            label: '位置来源',
            value: 'locationSource',
            type: 'select',
            default: 1,
            placeholder: '请选择位置来源',
            options: [
              {
                label: '车载设备定位',
                value: 1,
              },
              {
                label: 'APP位置',
                value: 2,
              },
            ],
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'equipment',
            type: 'input',
            placeholder: '请输入车牌号码',
            default: this.$route.query.plateNumber ? decodeURI(this.$route.query.plateNumber) : null,
          },
          { // 查询时间
            label: '查询时间',
            value: 'Date',
            type: 'date',
            default: [],
            placeholder: '请选择查询时间',
            attr: {
              type: 'daterange',
              format: 'yyyy-MM-dd HH:mm:ss',
            },
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.plateNumber': function (newVal) {
      if (this.$route.path === '/manage/operate/track/track' && newVal) {
        this.$refs.searchBox.setVal('equipment', decodeURI(this.$route.query.plateNumber));
        this.$refs.searchBox.sub();
      }
    },
  },
  methods: {
    setDefalutDate () {
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'default',
        value: [this.formatDate(new Date().setHours(0, 0, 0, 0), 1), this.formatDate(new Date().setHours(23, 59, 59, 999), 1)],
        names: ['Date'],
      });
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.Date && searchBoxData.Date[0]) {
        searchBoxData.startDate = this.formatDate(searchBoxData.Date[0], 1);
        searchBoxData.endDate = this.formatDate(searchBoxData.Date[1], 1);
      }
      if (searchBoxData.equipment == null) {
        return ;
      }
      delete searchBoxData.Date;
      this.$refs.mapBox.saveSearchBoxData(searchBoxData);
    },
  },
  created () {
    this.setDefalutDate();
  },
};
</script>

<style lang="scss" scoped>
</style>
